import Controller from "./accordionGroup.controller";
import template from "./accordionGroup.html";

const accordionGroup = {
  template,
  controller: Controller,
  transclude: true,
};

export default accordionGroup;



// WEBPACK FOOTER //
// ./src/components/accordionGroup/accordionGroup.component.js